/**
 * Fecha en YYYY-MM-DD según el calendario local del usuario.
 * Evita el desfase de un día que produce `toISOString().slice(0, 10)` (UTC).
 */
export function formatDateAsYyyyMmDdLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
